interface Props {
  message: string | null;
  variant?: 'error' | 'success';
}

export function Alert({ message, variant = 'error' }: Props) {
  if (!message) return null;
  // Annoncé aux lecteurs d'écran (12/10/2026) : une erreur interrompt
  // (`alert`), une confirmation attend son tour (`status`).
  return (
    <div className={`alert alert-${variant}`} role={variant === 'error' ? 'alert' : 'status'}>
      {message}
    </div>
  );
}
